import Select from "components/form/select";
import Input from "components/form/input";
import Info from "./info";

import { humanizedTime } from "utils/date";
import { Institution } from "types/institution";
import clsx from "clsx";

import { useState } from "react";

interface TimeCalculatorProps {
  institutions: Institution[];
  institution: Institution;
  setInstitutionName: (newInstitution: string) => void;
  loading: boolean;
}

export default function TimeCalculator(
  props: TimeCalculatorProps
): JSX.Element {
  const { institutions, institution, loading } = props;
  const { setInstitutionName } = props;

  const [testDay, setTestDay] = useState(1);
  const [writingTime, setWritingTime] = useState(60);

  const hasText = institution?.name !== "ENEM" || testDay === 1;

  function requiredResolutionTime() {
    if (!institution) return 0;

    const writingMinutes = hasText ? writingTime : 0;
    return Math.round(
      ((minutesToComplete() - writingMinutes) / institution.totalQuestions) * 60
    );
  }

  function minutesToComplete() {
    if (!institution) return 0;

    if (institution.name !== "ENEM" || testDay !== 1)
      return institution.minutesToComplete;
    return institution.minutesToComplete + 30;
  }

  return (
    <div
      className={clsx(
        "fade-loading flex-shrink-0 p-4 w-full bg-gray-50 rounded-lg md:p-7 md:w-1/2",
        { loading }
      )}
    >
      <div className="description mb-8">
        <span className="block mb-3 text-3xl font-semibold">Calculadora</span>
        <span>
          Se você levar {humanizedTime(writingTime * 60)} para escrever a
          redação, vai ter, em média,{" "}
          {humanizedTime(requiredResolutionTime(), true)} para resolver cada
          questão da prova
        </span>
      </div>
      <div className="input-fields md:h-[80px] flex flex-col w-full md:flex-row">
        <div className="w-full md:mr-4 md:w-1/2">
          <Select
            onSelect={({ value }) => setInstitutionName(value)}
            label="Instituição"
            name="institution"
            value={institution?.name}
            options={institutions.map((institution) => institution?.name)}
          />
        </div>
        {institution?.name === "ENEM" && (
          <div className="mt-4 w-full md:mt-0 md:w-1/2">
            <Select
              onSelect={({ value }) => setTestDay(value)}
              label="Dia do teste"
              name="test_day"
              value={testDay}
              options={[
                { label: "1º dia", value: 1 },
                { label: "2º dia", value: 2 }
              ]}
            />
          </div>
        )}
      </div>

      {hasText && (
        <div className="flex items-end mt-6">
          <div className="flex flex-col">
            <span className="block mb-2">Tempo de redação</span>
            <Input
              onChange={(value) => setWritingTime(value)}
              name="writing_time"
              type="number"
              value={String(writingTime)}
              min={0}
              max={minutesToComplete()}
            />
          </div>
          <span className="inline-block mb-2 ml-2">minutos</span>
        </div>
      )}

      <div className="flex flex-col mt-10 w-full md:flex-row">
        <Info
          label="Duração da prova"
          value={humanizedTime((minutesToComplete() || 0) * 60)}
          className="flex-shrink-0"
        />
        <Info
          label="Tempo disponível por questão"
          value={`${humanizedTime(requiredResolutionTime(), true)} por questão`}
          className="flex-grow mt-6 md:ml-8 md:mt-0"
        />
      </div>
    </div>
  );
}
